// Liga pública del boleto: /es/boleto?c=<código QR>. Los datos se leen al momento (si cambian en el panel, el boleto cambia).
// En la vista previa sin servidor los datos viven en el navegador; para abrirla en otro teléfono la liga lleva además
// una copia (?d=…) que solo se usa si ese teléfono no tiene la venta.
export type DatosBoleto = { etiqueta?: string; folio: string; codigo: string; tour: string; slug?: string; fecha: string; hora: string; camion?: string; adultos: number; ninos: number; total: number; nombre?: string; estado: string };

export { oficina } from "@/content/catalogo";
export const mapaPunto = "https://www.google.com/maps/search/?api=1&query=Hidalgo+1+A+Centro+Mazamitla+Jalisco";

const b64 = (d: unknown) => btoa(unescape(encodeURIComponent(JSON.stringify(d)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

/** Liga completa (para QR y WhatsApp). */
export function urlBoleto(codigo: string, idioma: "es" | "en" = "es", copia?: DatosBoleto) {
  const exportado = process.env.NEXT_PUBLIC_EXPORT === "1";
  const ruta = exportado ? `${idioma}/boleto/index.html` : `/${idioma}/boleto`;
  const q = `?c=${encodeURIComponent(codigo)}${exportado && copia ? `&d=${b64(copia)}` : ""}`;
  const destino = new URL(ruta + q, exportado ? document.baseURI : location.origin);
  if (typeof window !== "undefined" && !window.location.pathname.includes("/boleto")) destino.searchParams.set("volver", window.location.href);
  return destino.href;
}

/** Solo permite volver a otra vista de este mismo sitio, nunca a una URL externa. */
export function vueltaBoleto(valor: string | null) {
  if (typeof window === "undefined" || !valor) return null;
  try {
    const destino = new URL(valor, window.location.origin);
    return destino.origin === window.location.origin && !destino.pathname.includes("/boleto") ? destino.href : null;
  } catch { return null; }
}

/** Compatibilidad con ligas viejas de la demo. */
export function ligaBoleto(d: DatosBoleto, idioma: "es" | "en" = "es") {
  return urlBoleto(d.codigo, idioma, d);
}

export function leerDemo(d: string): DatosBoleto | null {
  try { return JSON.parse(decodeURIComponent(escape(atob(d.replace(/-/g, "+").replace(/_/g, "/"))))); } catch { return null; }
}
